<template>
  <div>
    <ValidationProvider
      :name="$t('change_detail_old_license_plate')"
      rules="required"
      v-slot="{ errors }"
    >
      <v-combobox
        v-model="originalLicensePlate"
        :items="licensePlateList"
        :disabled="isAllTextFieldDisable"
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_data')"
        :search-input.sync="searchInput"
        :loading="isLoadingLicensePlate"
        auto-select-first
        @change="changeLicensePlate"
        :error-messages="errors[0]"
        :ref="refName"
        @keyup.enter="keyupEnter"
      >
        <template v-slot:append-item>
          <div v-intersect="isScrollBarBottom" />
        </template>
        <template v-slot:label>
          <span class="red--text">
            <strong>* </strong>
          </span>
          {{ $t('change_detail_old_license_plate') }}
        </template>
      </v-combobox>
    </ValidationProvider>
  </div>
</template>

<script>
import { HttpCustomerLicensePlateMapping } from '@/js/http-Manager'

export default {
  name: 'LicensePlateCombobox',
  props: {
    fatherOriginalLicensePlate: {
      type: String
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    refName: {
      type: String
    }
  },
  data: () => ({
    originalLicensePlate: '',
    allLicensePlate: [],
    searchInput: null,
    page: 1,
    perPage: 10,
    tempWatchLicensePlate: '',
    searchCount: 0,
    getIntersectingObj: null,
    isGetLicensePlateFinish: false,
    isLoadingLicensePlate: false
  }),
  computed: {
    licensePlateList () {
      return this.allLicensePlate.map((item) => item.LicensePlate)
    }
  },
  async mounted () {
    this.originalLicensePlate = this.fatherOriginalLicensePlate
    await this.resetLicensePlateList(this.fatherOriginalLicensePlate)
  },
  watch: {
    async searchInput (val) {
      await this.resetLicensePlateList(val)
    },
    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isGetLicensePlateFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getLicensePlate()
        }
      }
    },
    async fatherOriginalLicensePlate (val) {
      await this.resetLicensePlateList(val)
    }
  },
  methods: {
    async resetLicensePlateList (val) {
      this.tempWatchLicensePlate = val
      this.page = 1
      this.allLicensePlate = []
      this.isGetLicensePlateFinish = true
      await this.getLicensePlateCount()
      await this.getLicensePlate()
      this.isGetLicensePlateFinish = false
    },
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    changeLicensePlate () {
      this.$emit('changeLicensePlate', this.originalLicensePlate)
    },
    async getLicensePlateCount () {
      let param = {
        LicensePlate: this.tempWatchLicensePlate
      }
      let response = await HttpCustomerLicensePlateMapping.GetCustomerLicensePlateMappingCount(
        param
      )
      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getLicensePlate () {
      if (this.searchCount > (this.page - 1) * this.perPage && this.searchCount !== 0) {
        this.isLoadingLicensePlate = true
        let param = {
          LicensePlate: this.tempWatchLicensePlate,
          Page: this.page,
          ItemsPerPage: this.perPage
        }
        let response = await HttpCustomerLicensePlateMapping.GetCustomerLicensePlateMappingList(
          param
        )
        if (response.status === 200) {
          this.allLicensePlate = [...this.allLicensePlate, ...response.data.Data]
        } else {
          this.allLicensePlate = []
        }
        this.isLoadingLicensePlate = false
      }
    },
    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    }
  }
}
</script>
